var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header-box"},[_c('div',{staticClass:"content_auto"},[_c('span',{staticClass:"page-header-content",class:{ back: _vm.isShowBackIcon },on:{"click":_vm.onClick}},[(_vm.isShowBackIcon)?_c('span',{staticClass:"icon"},[_vm._v("‹")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }